// Performance monitoring utilities for Core Web Vitals

export const measureCLS = () => {
  if (typeof window !== 'undefined') {
    // Track cumulative layout shift
    const observer = new PerformanceObserver((list) => {
      for (const entry of list.getEntries()) {
        console.log('CLS:', (entry as any).value);
      }
    });
    observer.observe({ entryTypes: ['layout-shift'] });
  }
};

export const measureFID = () => {
  if (typeof window !== 'undefined') {
    // Track first input delay
    const observer = new PerformanceObserver((list) => {
      for (const entry of list.getEntries()) {
        if (entry.entryType === 'first-input') {
          const fidEntry = entry as any;
          console.log('First Input Delay:', fidEntry.processingStart - fidEntry.startTime);
        }
      }
    });
    observer.observe({ entryTypes: ['first-input'] });
  }
};

export const measureLCP = () => {
  if (typeof window !== 'undefined') {
    // Track largest contentful paint
    const observer = new PerformanceObserver((list) => {
      for (const entry of list.getEntries()) {
        console.log('Largest Contentful Paint:', entry.startTime);
      }
    });
    observer.observe({ entryTypes: ['largest-contentful-paint'] });
  }
};

// Preload critical resources
export const preloadCriticalResources = () => {
  if (typeof document !== 'undefined') {
    // Preload hero image
    const heroImageLink = document.createElement('link');
    heroImageLink.rel = 'preload';
    heroImageLink.as = 'image';
    heroImageLink.href = '/src/assets/hero-lifestyle.jpg';
    document.head.appendChild(heroImageLink);
  }
};

// Optimize images with intersection observer
export const setupImageLazyLoading = () => {
  if (typeof window !== 'undefined' && 'IntersectionObserver' in window) {
    const imageObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const img = entry.target as HTMLImageElement;
          if (img.dataset.src) {
            img.src = img.dataset.src;
            img.classList.remove('lazy');
            imageObserver.unobserve(img);
          }
        }
      });
    });

    document.querySelectorAll('img[data-src]').forEach((img) => {
      imageObserver.observe(img);
    });
  }
};

// Initialize all performance monitoring
export const initPerformanceTracking = () => {
  measureFID();
  measureLCP();
  measureCLS();
  preloadCriticalResources();
  setupImageLazyLoading();
};